import { useQuery } from '@tanstack/react-query'
import { profileService } from '@/services/profileService'

/**
 * Hook to fetch a public profile by username
 */
export function usePublicProfile(username: string | undefined) {
  return useQuery({
    queryKey: ['publicProfile', username],
    queryFn: () => profileService.getPublicProfile(username!),
    enabled: !!username,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 1,
  })
}
